export default {
  error: (state) => state.error,
  isLoading: (state) => state.isLoading,
  isAdding: (state) => state.isAdding,
  isRefreshing: (state) => state.isRefreshing,
  ddStates: (state) => state.ddStates,
  riskStates: (state) => state.riskStates,
  list: (state) => state.list,
  paging: (state) => state.paging,
  summary: (state) => state.summary,
  nextPage: (state) => state.paging?.next_page,
};
